import React, { useState, useEffect, useRef } from 'react'
import { ChevronDown } from 'react-feather'
import {useKeypress} from "@/Utilities/Hooks";

export function Dropdown({title, placeholder, options, onSelect}) {

  const [selected, setSelected] = useState(false);
  const [open, setOpen] = useState(false);
  const container = useRef();

  useKeypress('Escape', () => {
    if (!open) {
      return;
    }
    setOpen(false);
  }, [open]);

  useEffect(() => {
    window.addEventListener('click', (e) => {
      if(container.current?.contains(e.target)) {
        return;
      }
      setOpen(false);
    })
  });

  function handleSelect(e) {
    const value = e.target.dataset?.value;
    const label = e.target.innerText;
    setSelected(label);
    if(typeof onSelect === 'function') onSelect(value);
    setOpen(false);
  }

  return (
    <>
      <div className="relative" ref={container}>
        <div className="flex flex-row mr-4 text-sm cursor-pointer" onClick={() => { setOpen(!open) }}>
          <span className="mr-2">{ title }</span><span title={ selected || placeholder } className="font-bold max-w-[150px] truncate">{ selected || placeholder }</span><ChevronDown />
        </div>
        {open &&
          <div className="absolute bottom-0 z-40 min-w-full p-4 text-white translate-y-full rounded-md bg-gray-darker w-fit">
            {options && options.map((o, i) => (
              <button key={i} data-value={o.id || o.value} className="text-left w-full underline p-1 block whitespace-nowrap hover:no-underline hover:bg-gray-dark" onClick={handleSelect}>{o.name || o.label}</button>
            ))}
          </div>
        }
      </div>

    </>
  );
}
